module.exports = __webpack_public_path__ + "img/paywall3-left.752cf4c3.png";